import React from 'react';
import PropTypes, { any } from 'prop-types';

import styles from './matchSheetRoundData.scss';
import Round from './Round';

const MatchSheetRoundData = (props) => {
    const { roundsToDisplay, match } = props;

    const rounds = Array(roundsToDisplay).fill(null).map((_, index) => index + 1);

    return (
        <div className={styles.matchSheetRoundData}>
            {rounds.map((round) => {
                return (
                    <Round
                        key={`round-${round}`}
                        gamesToDisplay={21}
                        round={round}
                        totalRounds={roundsToDisplay}
                        match={match}
                    />
                );
            })}
        </div>
    );
};

MatchSheetRoundData.propTypes = {
    roundsToDisplay: PropTypes.number,
    match: PropTypes.objectOf(any).isRequired,
};

MatchSheetRoundData.defaultProps = {
    roundsToDisplay: 1,
};

export default MatchSheetRoundData;
